// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 289 ? "__federation_expose_App" : chunkId) + "." + {"289":"1e7531b3d2903a9fa70d","412":"dd4b6a2f86383d800815"}[chunkId] + ".js";
};